import React from 'react';
interface TableProps {
  headers: string[];
  rows: (string | React.ReactNode)[][];
  caption?: string;
}
const Table: React.FC<TableProps> = ({
  headers,
  rows,
  caption
}) => {
  // Helper function to determine if cell content contains color indicators
  const getCellColorClass = (content: string | React.ReactNode): string => {
    if (typeof content !== 'string') return '';
    if (content.includes('(Green)')) return 'bg-green-50';
    if (content.includes('(Orange)')) return 'bg-orange-50';
    if (content.includes('(Red)')) return 'bg-red-50';
    return '';
  };
  return <div className="overflow-x-auto shadow rounded-lg my-6" data-id="element-129">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-130">
        {caption && <caption className="text-sm font-medium text-gray-500 p-4 text-left bg-gray-50 border-b border-gray-200" data-id="element-131">
            {caption}
          </caption>}
        <thead className="bg-gray-50" data-id="element-132">
          <tr data-id="element-133">
            {headers.map((header, idx) => <th key={idx} scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-134">
                {header}
              </th>)}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-135">
          {rows.map((row, rowIdx) => <tr key={rowIdx} className={rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-136">
              {row.map((cell, cellIdx) => {
            const colorClass = typeof cell === 'string' ? getCellColorClass(cell) : '';
            return <td key={cellIdx} className={`px-6 py-4 whitespace-normal text-sm text-gray-900 ${colorClass}`} data-id="element-137">
                    {cell}
                  </td>;
          })}
            </tr>)}
        </tbody>
      </table>
    </div>;
};
export default Table;